import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations } from '../i18n/translations';
type Language = 'es' | 'en';
type LanguageContextType = {
  language: Language;
  toggleLanguage: () => void;
  t: (typeof translations)['es'];
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [language, setLanguage] = useState<Language>('es');
  useEffect(() => {
    // Check URL param on mount
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get('lang');
    if (langParam === 'en' || langParam === 'es') {
      setLanguage(langParam);
    }
  }, []);
  const toggleLanguage = () => {
    const newLang = language === 'es' ? 'en' : 'es';
    setLanguage(newLang);
    // Update URL without reload
    const url = new URL(window.location.href);
    url.searchParams.set('lang', newLang);
    window.history.replaceState({}, '', url.toString());
  };
  const value = {
    language,
    toggleLanguage,
    t: translations[language]
  };
  return <LanguageContext.Provider value={value} data-id="element-472" data-mp="d0hgm2jp38ed">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};